import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, signal } from '@angular/core';
import { SelectV2Module, ButtonV3Component, IconV3Component } from '@gea/digital-ui-lib';
import { StyleClassModule } from 'primeng/styleclass';
import { Router } from '@angular/router';

export interface NewsBanner {
  imagePath: string;
  mainText: string;
  secondaryText: string;
  checkoutLink: string;
}

@Component({
  selector: 'app-news-banner',
  imports: [SelectV2Module, StyleClassModule, ButtonV3Component, IconV3Component],
  templateUrl: './news-banner.component.html',
  styleUrl: './news-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsBannerComponent {
  @Input() newsBannerData = signal<NewsBanner>({
    imagePath: '',
    mainText: '',
    secondaryText: '',
    checkoutLink: '',
  });
  @Output() closeBanner: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private readonly router: Router,
    @Inject(Window) private window: Window
  ) {}

  closeNewsBanner(): void {
    this.closeBanner.emit(true);
  }

  goToCheckoutLink(path: string): void {
    if (path.startsWith('http')) {
      this.window.open(path, '_blank');
    } else {
      this.router.navigate([path]);
    }
  }
}
